import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for BasicPlanConversionStatusStore, for use in the registry */ export const BasicPlanConversionStatusStoreActionTypes = [
    ActionType.BasicPlanConversionSucceededAction,
    ActionType.ConvertBasicPlanToPremiumAction,
    ActionType.ConvertBasicPlanToPremiumFailedAction,
    ActionType.ConvertBasicPlanToPremiumSucceededAction,
    ActionType.FetchConvertPlanStatusFailedAction,
    ActionType.FetchConvertPlanStatusSucceededAction
];
